import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import { ChevronForwardIcon } from "@jti/brand-icons/chevron-forward";
import { useDirection } from "@jti/fe-common";
import { LinkBehaviour } from "../../../components/LinkBehaviour";
import styles from "./BreadcrumbItem.module.scss";
export const BreadcrumbItem = ({ title, url, hasPrev, isHidden }) => {
    const direction = useDirection();
    return (_jsxs("li", { className: classNames(styles.breadcrumbItem, { [styles.hidden]: isHidden }), children: [hasPrev ? _jsx(ChevronForwardIcon, { direction: direction, className: styles.breadcrumbChevron }) : null, _jsx(LinkBehaviour, { className: styles.breadcrumbLink, href: url, children: title })] }));
};
//# sourceMappingURL=BreadcrumbItem.js.map